import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { NavigationService } from '../../services/navigation.service';
import { EnrollmentService } from '../../services/enrollment.service';
import { MatDialog } from '@angular/material/dialog';
import { ForgotConfirmationComponent } from '../../reusable-components/forgot-confirmation/forgot-confirmation.component';
import { ModalService } from 'src/app/services/modal.service';
import { PersistenceService } from '../../services/persistence.service';
import { Router } from '@angular/router';
import { RememberService } from 'src/app/services/remember.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { RegistrationService } from 'src/app/services/registration.service';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginID;
  regcode;
  confirmationNo;
  emailAddress;
  errorMsg;
  TrackFocusDirective;
  isFormCompleted = false;
  isSubmitting = false;
  rememberme=false;
  foundcookie=false;
  onsite=true;
  attendee;
  active = 1;
  today;

  constructor(
    private authenticationService: AuthenticationService,
    private navigationService: NavigationService,
    private enrollmentService: EnrollmentService,
    public dialog: MatDialog,
    public modalService: ModalService,
    private persistenceService: PersistenceService,
    private router: Router,
    private rememberService: RememberService,
    private configService: ConfigurationService,
    private registrationService: RegistrationService,

  ) {
    this.configService.fetchConfig().then(conf=>{
      this.onsite = conf.onsite;
      if(this.onsite){
        this.active=2;
      }

    });
    this.persistenceService.clear();
    let member = this.rememberService.getCookie();
    if(member){
      this.rememberme = true;
      this.foundcookie = true;
      this.confirmationNo = member.confcode;
      this.emailAddress = member.email;
    }
  }

  ngOnInit(): void {
    this.today = new Date().toJSON();
  }

  backhome() {
    //redirect to content site
    const env = window.location.hostname;

    if (env.indexOf('localhost') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('local') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('dev') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('test') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    } else if (env.indexOf('content') >= 0) {
      window.location.href = "http://www.lplfinancialfocus.com/";
    }
  }


  declineButtonClick() {

    this.persistenceService.testStorage();
    this.persistenceService.clear();

    const creds: any = {};
    console.log(this.loginID);
    creds.username = this.loginID;
    creds.password = 'password';

    if (this.loginID) {
      this.authenticationService.initialLogin(creds, this.regcode).then(() => {
        //  promise resolved
        //this.router.navigate(['/invitation']);
        this.authenticationService.updateProfile('CANCELLED', "Declined from Login Page").subscribe(() => {
          this.router.navigate(['decline']);
      });

      }, (err) => {
        this.errorMsg = err;
      });
    }

  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }

  openForgotConf(): void {
    let dialogRef = this.dialog.open(ForgotConfirmationComponent, { panelClass: 'forgot-dialog-container' });

    // dialogRef.afterClosed().subscribe(result => {
    //   console.log('The dialog was closed');
    //   this.animal = result;
    // });
  }

  forward() {
    if(!this.isSubmitting){
      this.isSubmitting =true;
      const creds: any = {};
      this.isFormCompleted = true;
      if(this.foundcookie && !this.rememberme){
        this.rememberService.deleteCookie();
      }
      if (this.confirmationNo) {
        if (this.emailAddress) {
          creds.confirmationCode = this.confirmationNo;
          creds.emailAddress = this.emailAddress;
          this.authenticationService.rvsLogin(creds).then(() => {
            //  authService resolved
            this.enrollmentService.rvsGetEnrollment().then(() => {
              this.attendee = this.registrationService.getAttendee({});

              if (this.attendee.PAXTypeNo !== 38) {
                if(!this.foundcookie && this.rememberme){
                  this.rememberService.setCookie(this.confirmationNo, this.emailAddress);
                }
                // enrollmentService resolved
                this.navigationService.forwardrvs();
              } else {
                this.isSubmitting =false;
                this.errorMsg = 'Invalid Confirmation';
                  window.scrollTo(0, 0);
              }
            });
          }, (err) => {
            this.isSubmitting =false;
            this.errorMsg = err;
          });
        } else {
          this.isSubmitting =false;
          this.errorMsg =
            'Enter your email address with your confirmation number.';
        }
      } else if (this.loginID) {
        creds.username = this.loginID;
        creds.password = 'password';
        this.authenticationService.initialLogin(creds, this.regcode).then(() => {
          // promise resolved
          if(this.regcode){
            this.authenticationService.mapRegCode(this.regcode);
          }
          this.navigationService.forward();
        }, (err) => {
          this.isSubmitting =false;
          this.errorMsg = err;
        });
      } else {
        this.isSubmitting =false;
        this.errorMsg = 'Please enter a Login ID or Confirmation Code.';
      }
    }
  }

}
